export const state = {
  formData: null,
}

export const mutations = {
  SET_FORM_DATA(state, data) {
    state.formData = data
  },
}
